export default __webpack_public_path__ + "static/1-b95f3e9586f55d769001edc3fa9b9642.png";